<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';

const backendApi = inject('backendApi');

const emit = defineEmits(['update']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const searchQuery = ref('');
const loading = ref(true);
const statusType = ref([]);
const showRetryButton = ref(false);

const getStatusType = () => {
    cleanData();

    backendApi()
        .stepStatus()
        .index({
            pattern: searchQuery.value,
            active: true,
            exclude: 'delivered,initStep'
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        statusType.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    statusType.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getStatusType());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        item-title="name"
        item-value="id"
        :items="statusType"
        :label="hideLabel ? '' : $t('Status')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getStatusType"
        @retry="getStatusType"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name} ${item.raw.city ? `(${item.raw.city.name})` : ''}`"
                :subtitle="`${item.raw.place ? item.raw.place : ''}`"
            >
            </v-list-item>
        </template>

        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
